<template>
  <div>
    <bg-section-video></bg-section-video>
    <!-- <div class="image-map-container">
      <heatmapjs-vue class="heatmapjs-container" :max="30" :min="0" :data="fakeBoy"></heatmapjs-vue>
      <img src="./screenshot.png" />
    </div>
    <div class="background-radar">
      <bg-radar-chart :chartData="radarData" />
    </div>-->
  </div>
</template>

<style>
.heatmapjs-container {
  position: absolute !important;
  height: 4900px;
  width: 1280px;
}
.image-map-container {
  height: 1920px;
  width: 1280px;
  position: relative;
}
.background-radar {
  background-color: var(--bg-color-gray-dark);
  padding: 40px;
}
</style>

<script>
import BgSectionVideo from "@/components/bg-section-video";
import BgRadarChart from "@/components/bg-radar-chart";

import fakeData from "./data.json";
import eyeData from "./eyeData.json";
import mouseData from "./mouseData.json";
import moment from "moment";
export default {
  components: { BgSectionVideo, BgRadarChart },
  data() {
    return {
      fakeBoy: [],
      radarData: {
        labels: [
          "Running",
          "Swimming",
          "Eating",
          "Cycling",
          "Eating doo doo",
          "death",
        ],
        datasets: [
          {
            data: [14, 10, 16, 9, 14, 12],
            borderColor: "#fff",
            pointBackgroundColor: "#fff",
            backgroundColor: "rgba(255,255,255,0.2)",
            pointLabelFontColor: "#fff",
            radius: 6,
            pointRadius: 6,
            pointBorderWidth: 3,
            pointBackgroundColor: "#fff",
            pointBorderColor: "#fff",
            pointHoverRadius: 10,
            labels: {
              fontColor: "#fff",
            },
          },
        ],
      },
    };
  },
  created() {
    // const formattedFakeData = fakeData.map(item => {
    //   return {
    //     x: item.mouseX,
    //     y: item.mouseY + item.vScroll,
    //     value: 5
    //   };
    // });
    // const sliced = eyeData;
    // const slicedMouse = mouseData;
    // const matchingUpScrollEye = sliced.map(item => {
    //   console.log(item);
    //   const scrollX = slicedMouse.find(time => {
    //     const duration = moment(item.timestamp).diff(
    //       time.timestamp,
    //       "milliseconds"
    //     );
    //     return duration < 1000 && duration > -1000;
    //   });
    //   console.log(item.x);
    //   return {
    //     x: item.x,
    //     y: scrollX ? item.y + scrollX.vScroll : item.y,
    //     value: 8
    //   };
    // });
    // this.fakeBoy = matchingUpScrollEye;
  },
};
</script>
